import { render } from "./SiteNavigation.vue?vue&type=template&id=4c971ae5"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/rexvalkering-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__